import { render, staticRenderFns } from "./LeftAndRight.vue?vue&type=template&id=0d1dade0&scoped=true&"
import script from "./LeftAndRight.vue?vue&type=script&lang=js&"
export * from "./LeftAndRight.vue?vue&type=script&lang=js&"
import style0 from "./LeftAndRight.vue?vue&type=style&index=0&id=0d1dade0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1dade0",
  null
  
)

export default component.exports